module.exports = __webpack_public_path__ + "img/brandImg11.d8fbb8b9.jpg";